import React from "react";
import { CONSTANTS } from "constant/Content";
import { Container, Row, Col } from "reactstrap";
import { BsShieldX } from "react-icons/bs"
import { SlScreenDesktop } from "react-icons/sl"
import { FiSmartphone } from "react-icons/fi"
import { VscRocket } from "react-icons/vsc"
// import { CONSTANTS } from "constant/Content";

function ServiceIntro() {

  const headingStyles = {
    color: "black",
    textTransform: "uppercase"
  }

  return (
    <>
      <Container className="eachSectionMarginTop service-intro-seciton" data-aos="slide-right" data-aos-duration="1500" data-aos-offset="200">
        <Row className="justify-content-center">
          <Col className="col-lg-5 mr-auto mb-5 p-5 p-md-0 col-12" >
            <span className="d-block text-uppercase lead  p-0 m-0">Featured Services</span>
            <span className="divider my-4"></span>
            <h2 className="mb-4 font-weight-300" style={headingStyles}>The <strong className="font-weight-700">Services</strong> That we are providing</h2>
            <p className="mb-4">
            {CONSTANTS.homepage.main.line6}
              <br></br><br></br>
            {CONSTANTS.homepage.main.line7}
            </p>
            <button className='themeBtn2 py-2 px-4'>{CONSTANTS.blogSection.blog.button}</button>
          </Col>
          <Col className="col-lg-6  p-5 p-md-0">
            <Row className="mt-5">
              <Col className="col-lg-6 col-md-6 mb-4">
                <div className="service">
                  <span className="icon icon-shield mb-4 d-block"><BsShieldX /></span>
                  <h3>{CONSTANTS.servicePage.featureServies.title1}</h3>
                  <p>{CONSTANTS.servicePage.featureServies.line1}</p>
                </div>
              </Col>
              <Col className="col-lg-6 col-md-6 mb-4">
                <div className="service">
                  <span className="icon icon-shield mb-4 d-block"><SlScreenDesktop /></span>
                  <h3>{CONSTANTS.servicePage.featureServies.title2}</h3>
                  <p>{CONSTANTS.servicePage.featureServies.line2}</p>
                </div>
              </Col>
              <Col className="col-lg-6 col-md-6 mb-4">
                <div className="service">
                  <span className="icon icon-shield mb-4 d-block"><FiSmartphone /></span>
                  <h3>{CONSTANTS.servicePage.featureServies.title3}</h3>
                  <p>{CONSTANTS.servicePage.featureServies.line3}</p>

                </div>
              </Col>
              <Col className="col-lg-6 col-md-6 mb-4">
                <div className="service">
                  <span className="icon icon-shield mb-4 d-block"><VscRocket /></span>
                  <h3>{CONSTANTS.servicePage.featureServies.title4}</h3>
                  <p>{CONSTANTS.servicePage.featureServies.line4}</p>
                </div>
              </Col>

            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ServiceIntro;
